
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

type Notification = {
  id: number;
  title: string;
  description: string;
  time: string;
  unread: boolean;
};

const recentNotifications: Notification[] = [
  {
    id: 1,
    title: "Welcome to ClubMate!",
    description: "Complete your profile to get started",
    time: "Just now",
    unread: true
  },
  {
    id: 2,
    title: "Profile Verification",
    description: "Submit your documents for verification",
    time: "2 hours ago",
    unread: true
  }
];

export const NotificationsCard = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Recent Notifications</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {recentNotifications.map((notification) => (
            <div 
              key={notification.id}
              className="flex items-start gap-4 p-4 rounded-lg hover:bg-muted transition-colors"
            >
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h4 className="font-medium">{notification.title}</h4>
                  {notification.unread && (
                    <span className="w-2 h-2 bg-primary rounded-full" />
                  )}
                </div>
                <p className="text-sm text-muted-foreground mt-1">
                  {notification.description}
                </p>
                <span className="text-xs text-muted-foreground mt-2 block">
                  {notification.time}
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
